import { createFileRoute } from '@tanstack/react-router'

interface IExportsSearch {
  page?: number
}

export const Route = createFileRoute('/_authenticated/exports')({
  staticData: { title: 'Exports' },
  validateSearch: (search: Record<string, unknown>): IExportsSearch => ({
    page: Number(search.page) > 1 ? Number(search.page) : undefined,
  }),
})
